import { Capacitor } from '@capacitor/core';

let Badge: any = null;

// Lazy-load the native badge plugin only on native platforms
const getBadge = async () => {
  if (Badge) return Badge;
  if (Capacitor.isNativePlatform()) {
    try {
      const mod = await import('@capawesome/capacitor-badge');
      Badge = mod.Badge;
      return Badge;
    } catch {
      return null;
    }
  }
  return null;
};

export const badgeService = {
  /** Set badge count on the app icon. Pass 0 to clear. */
  async set(count: number) {
    const badge = await getBadge();
    if (!badge) return;
    try {
      const { isSupported } = await badge.isSupported();
      if (!isSupported) return;
      await badge.set({ count: Math.max(0, count) });
    } catch (e) {
      console.warn('[BadgeService] set failed:', e);
    }
  },

  /** Clear the badge (set to 0). */
  async clear() {
    const badge = await getBadge();
    if (!badge) return;
    try {
      await badge.clear();
    } catch (e) {
      console.warn('[BadgeService] clear failed:', e);
    }
  },

  /** Request permission (needed on some Android versions). */
  async requestPermission() {
    const badge = await getBadge();
    if (!badge) return;
    try {
      await badge.requestPermissions();
    } catch (e) {
      console.warn('[BadgeService] requestPermission failed:', e);
    }
  },
};
